var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#5B6DEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48125 8.44883C7.16743 8.44722 6.85413 8.47433 6.54525 8.52983C6.7995 6.17858 8.75925 4.39771 11.0925 4.39771C12.5212 4.39771 13.5 5.09746 13.5 6.54533C13.5 7.99377 12.3249 8.69352 10.611 8.69352C9.34538 8.69352 8.74688 8.44883 7.48125 8.44883ZM7.389 9.30664C5.67506 9.30664 4.5 10.007 4.5 11.4548C4.5 12.9027 5.47875 13.6025 6.9075 13.6025C9.24075 13.6025 11.2005 11.8221 11.4548 9.47033C11.1459 9.52583 10.8326 9.55294 10.5188 9.55133C9.25313 9.55133 8.65406 9.30664 7.389 9.30664Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnt);
export default __webpack_public_path__ + "static/media/snt.0f59b7efdf75efed1ca043baac27d095.svg";
export { ForwardRef as ReactComponent };